// Write your code here.
import './index.css'

const EmojiCard = props => {
  const {details, onClickEmoji} = props
  const {emojiUrl, emojiName, id} = details
  const onClickX = () => {
    onClickEmoji(id)
  }
  return (
    <li className="emoji-card">
      <button className="button-emoji-item" type="button" onClick={onClickX}>
        <img src={emojiUrl} className="emoji-img" alt={emojiName} />
      </button>
    </li>
  )
}

export default EmojiCard
